export const SET_WEIGHT_TARGET_STEP = 'SET_WEIGHT_TARGET_STEP';
export const REQUEST_WEIGHT_TARGET_INFO = 'REQUEST_WEIGHT_TARGET_INFO';
export const REQUEST_WEIGHT_TARGET_INFO_SUCCESS = 'REQUEST_WEIGHT_TARGET_INFO_SUCCESS';
export const REQUEST_WEIGHT_TARGET_CALC = 'REQUEST_WEIGHT_TARGET_CALC';
export const REQUEST_WEIGHT_TARGET_CALC_SUCCESS = 'REQUEST_WEIGHT_TARGET_CALC_SUCCESS';
export const SET_TARGET_WEIGHT = 'SET_TARGET_WEIGHT';
export const REQUEST_WEIGHT_TARGET_SAVE = 'REQUEST_WEIGHT_TARGET_SAVE';
export const REQUEST_WEIGHT_TARGET_SAVE_SUCCESS = 'REQUEST_WEIGHT_TARGET_SAVE_SUCCESS';
export const REQUEST_WEIGHT_TARGET_SAVE_FAIL = 'REQUEST_WEIGHT_TARGET_SAVE_FAIL';
export const INITIAL_TARGET_SET_DONE = 'INITIAL_TARGET_SET_DONE';
export const LOAD_CURRENT_TARGET_INFO = 'LOAD_CURRENT_TARGET_INFO';
export const LOADED_CURRENT_TARGET_INFO = 'LOADED_CURRENT_TARGET_INFO';
export const REQUEST_WEIGHT_TARGET_RESET = 'REQUEST_WEIGHT_TARGET_RESET';
export const REQUEST_WEIGHT_TARGET_RESET_SUCCESS = 'REQUEST_WEIGHT_TARGET_RESET_SUCCESS';
export const UPDATE_MILESTONE_REQUEST = 'UPDATE_MILESTONE_REQUEST';
export const UPDATE_MILESTONE_REQUEST_SUCCESS = 'UPDATE_MILESTONE_REQUEST_SUCCESS';
export const SET_PAL_VALUE = 'SET_PAL_VALUE';
export const SET_HAS_SCALE = 'SET_HAS_SCALE';
export const REQUEST_CONTINUE_TO_SET_TARGET = 'REQUEST_CONTINUE_TO_SET_TARGET';
export const REQUEST_CONTINUE_TO_SET_TARGET_SUCCESS = 'REQUEST_CONTINUE_TO_SET_TARGET_SUCCESS';
export const REQUEST_CONTINUE_TO_SET_TARGET_FAILURE = 'REQUEST_CONTINUE_TO_SET_TARGET_FAILURE';
export const LOAD_CHANGE_TARGET_SCREEN_REQUEST = 'LOAD_CHANGE_TARGET_SCREEN_REQUEST';
export const LOAD_CHANGE_TARGET_SCREEN_SUCCESS = 'LOAD_CHANGE_TARGET_SCREEN_SUCCESS';
export const LOAD_CHANGE_TARGET_SCREEN_FAILURE = 'LOAD_CHANGE_TARGET_SCREEN_FAILURE';
export const CLOSE_TARGET_ADJUST_SCREEN = 'CLOSE_TARGET_ADJUST_SCREEN';
export const REMOVE_TARGET_REQUEST = 'REMOVE_TARGET_REQUEST';
export const REMOVE_TARGET_SUCCESS = 'REMOVE_TARGET_SUCCESS';
export const REMOVE_TARGET_FAILURE = 'REMOVE_TARGET_FAILURE';
export const SHOW_CONTINUE_ON_APP_SCREEN = 'SHOW_CONTINUE_ON_APP_SCREEN';
